import { FAQPageJsonLd } from "next-seo"
import * as Sentry from "@sentry/nextjs";

export function FAQPageSEO({mainEntity}){
    return <FAQPageJsonLd mainEntity={mainEntity} />
}